import type { TrainingPlanItem } from '../../types/trainingSession';
import type { Drill } from '../../types/drill';

export const MAX_PLAN_ITEMS = 30;

export const emptyItem = (): TrainingPlanItem => ({ title: '', durationMinutes: null, description: '', diagram: null });

export const totalMinutes = (items: TrainingPlanItem[]) =>
  items.reduce((sum, item) => sum + (item.durationMinutes || 0), 0);

/** Üres (még ki sem töltött) blokk - ezt a beemelés lecseréli, nem mögé fűz. */
export const isBlankItem = (item: TrainingPlanItem) =>
  !item.title.trim() && !item.description?.trim() && !item.diagram && !item.durationMinutes;

/** Van-e olyan blokk, amibe írtak, de nincs neve (mentéskor elveszne). */
export const hasUntitledContent = (items: TrainingPlanItem[]) =>
  items.some((i) => !i.title.trim() && (i.description?.trim() || i.durationMinutes || i.diagram));

/** A mentendő blokkok: név nélküliek nélkül, levágott szövegekkel. */
export const cleanItems = (items: TrainingPlanItem[]): TrainingPlanItem[] =>
  items
    .filter((i) => i.title.trim())
    .map((i) => ({
      title: i.title.trim(),
      durationMinutes: i.durationMinutes || null,
      description: i.description?.trim() || null,
      diagram: i.diagram || null,
    }));

/** Gyakorlattári gyakorlat edzésterv-blokká alakítva (másolat). */
export const drillToBlock = (drill: Drill): TrainingPlanItem => ({
  title: drill.title,
  durationMinutes: drill.durationMinutes ?? null,
  description:
    [drill.description, drill.equipment ? `Eszközök: ${drill.equipment}` : null, drill.players ? `Létszám: ${drill.players}` : null]
      .filter(Boolean)
      .join('\n\n') || null,
  diagram: drill.diagram ?? null,
});

/** Blokkok hozzáfűzése: az egyetlen üres kezdő blokkot lecseréli. */
export const appendItems = (prev: TrainingPlanItem[], added: TrainingPlanItem[]): TrainingPlanItem[] =>
  [...prev.filter((i) => !isBlankItem(i)), ...added.map((i) => ({ ...i }))].slice(0, MAX_PLAN_ITEMS);
